// extracted by mini-css-extract-plugin
export default {"base":"home_base__mNIML","body":"home_body__uji77","mask":"home_mask__nvZUk","blurred":"home_blurred__VqyYn"};